"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.zip = exports.get = exports.omit = exports.pick = exports.listify = exports.clone = exports.upperize = exports.lowerize = exports.invert = exports.mapEntries = exports.mapValues = exports.mapKeys = exports.shake = void 0;
var typed_1 = require("./typed");
/**
 * Removes (shakes out) undefined entries from an
 * object. Optional second argument shakes out values
 * by custom evaluation.
 */
var shake = function (obj, filter) {
    if (filter === void 0) { filter = function (x) { return x === undefined; }; }
    if (!obj)
        return {};
    return Object.keys(obj).reduce(function (acc, key) {
        var _a;
        if (filter(obj[key])) {
            return acc;
        }
        else
            return __assign(__assign({}, acc), (_a = {}, _a[key] = obj[key], _a));
    }, {});
};
exports.shake = shake;
/**
 * Map over all the keys of an object to return
 * a new object
 */
var mapKeys = function (obj, mapFunc) {
    return Object.keys(obj).reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[mapFunc(key, obj[key])] = obj[key], _a)));
    }, {});
};
exports.mapKeys = mapKeys;
/**
 * Map over all the keys to create a new object
 */
var mapValues = function (obj, mapFunc) {
    return Object.keys(obj).reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[key] = mapFunc(obj[key], key), _a)));
    }, {});
};
exports.mapValues = mapValues;
/**
 * Map over all the keys to create a new object
 */
var mapEntries = function (obj, toEntry) {
    if (!obj)
        return {};
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        var _c = toEntry(key, value), newKey = _c[0], newValue = _c[1];
        return __assign(__assign({}, acc), (_b = {}, _b[newKey] = newValue, _b));
    }, {});
};
exports.mapEntries = mapEntries;
/**
 * Returns an object with { [keys]: value }
 * inverted as { [value]: key }
 */
var invert = function (obj) {
    if (!obj)
        return {};
    return Object.keys(obj).reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[obj[key]] = key, _a)));
    }, {});
};
exports.invert = invert;
/**
 * Convert all keys in an object to lower case
 */
var lowerize = function (obj) {
    return (0, exports.mapKeys)(obj, function (k) { return k.toLowerCase(); });
};
exports.lowerize = lowerize;
/**
 * Convert all keys in an object to upper case
 */
var upperize = function (obj) {
    return (0, exports.mapKeys)(obj, function (k) { return k.toUpperCase(); });
};
exports.upperize = upperize;
var clone = function (obj) {
    return Object.getOwnPropertyNames(obj).reduce(function (acc, name) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[name] = obj[name], _a)));
    }, {});
};
exports.clone = clone;
/**
 * Convert an object to a list, mapping each entry
 * into a list item
 */
var listify = function (obj, toItem) {
    if (!obj)
        return [];
    var entries = Object.entries(obj);
    if (entries.length === 0)
        return [];
    return entries.reduce(function (acc, entry) {
        return __spreadArray(__spreadArray([], acc, true), [toItem(entry[0], entry[1])], false);
    }, []);
};
exports.listify = listify;
/**
 * Pick a list of properties from an object
 * into a new object
 */
var pick = function (obj, keys) {
    if (!obj)
        return {};
    return keys.reduce(function (acc, key) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = obj[key], _a));
    }, {});
};
exports.pick = pick;
/**
 * Omit a list of properties from an object
 * returning a new object with the properties
 * that remain
 */
var omit = function (obj, keys) {
    if (!obj)
        return {};
    if (!keys || keys.length === 0)
        return obj;
    return keys.reduce(function (acc, key) {
        // Gross, I know, it's mutating the object, but we
        // are allowing it in this very limited scope due
        // to the performance implications of an omit func.
        // Not a pattern or practice to use elsewhere.
        delete acc[key];
        return acc;
    }, __assign({}, obj));
};
exports.omit = omit;
var get = function (value, getter, defaultValue) {
    var _a;
    if (defaultValue === void 0) { defaultValue = null; }
    try {
        return (_a = getter(value)) !== null && _a !== void 0 ? _a : defaultValue;
    }
    catch (_b) {
        return defaultValue;
    }
};
exports.get = get;
/**
 * Zip two objects together recursivly into a new
 * object applying values from right to left.
 * Recursion only applies to child object properties.
 */
var zip = function (a, b) {
    if (!a && !b)
        return {};
    if (!a)
        return b;
    if (!b)
        return a;
    return Object.entries(a).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return __assign(__assign({}, acc), (_b = {}, _b[key] = (function () {
            if ((0, typed_1.isObject)(value))
                return (0, exports.zip)(value, b[key]);
            return b[key];
        })(), _b));
    }, {});
};
exports.zip = zip;
//# sourceMappingURL=object.js.map